import * as io from 'io-ts';
export var MoneyValue = io.Int;
export var Money = io.type({
  currency: io.string,
  value: MoneyValue
});